"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeDrillingActivationPostMessageData = void 0;
var tslib_1 = require("tslib");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
var getUriFromPairByIdentifier = function (identifier, uriIdentifierPairs, excludeUris) {
    var resolvedPair = uriIdentifierPairs
        .filter(function (result) { return !includes_1.default(excludeUris, result.uri); })
        .find(function (result) { return result.identifier === identifier; });
    return resolvedPair === null || resolvedPair === void 0 ? void 0 : resolvedPair.uri;
};
/**
 * @internal
 */
exports.sanitizeDrillingActivationPostMessageData = function (workspace, postMessageData, idToUriConverter) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var uris, identifiers, composedFrom, simpleUris, simpleIdentifiers, composedFromUris, composedFromIdentifiers, allIdentifiers, urisFromIdentifiers, _a, allUris, allComposedFromUris;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                uris = postMessageData.uris, identifiers = postMessageData.identifiers, composedFrom = postMessageData.composedFrom;
                simpleUris = isArray_1.default(uris) ? uris : [];
                simpleIdentifiers = isArray_1.default(identifiers) ? identifiers : [];
                composedFromUris = (composedFrom === null || composedFrom === void 0 ? void 0 : composedFrom.uris) && isArray_1.default(composedFrom.uris) ? composedFrom.uris : [];
                composedFromIdentifiers = (composedFrom === null || composedFrom === void 0 ? void 0 : composedFrom.identifiers) && isArray_1.default(composedFrom.identifiers) ? composedFrom.identifiers : [];
                allIdentifiers = uniq_1.default(tslib_1.__spreadArrays(simpleIdentifiers, composedFromIdentifiers));
                if (!allIdentifiers.length) return [3 /*break*/, 2];
                return [4 /*yield*/, idToUriConverter(workspace, allIdentifiers)];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = [];
                _b.label = 3;
            case 3:
                urisFromIdentifiers = _a;
                allUris = uniq_1.default(tslib_1.__spreadArrays(simpleUris, compact_1.default(simpleIdentifiers.map(function (identifier) {
                    return getUriFromPairByIdentifier(identifier, urisFromIdentifiers, simpleUris);
                }))));
                allComposedFromUris = uniq_1.default(tslib_1.__spreadArrays(composedFromUris, compact_1.default(composedFromIdentifiers.map(function (identifier) {
                    return getUriFromPairByIdentifier(identifier, urisFromIdentifiers, composedFromUris);
                }))));
                return [2 /*return*/, { uris: allUris, composedFrom: { uris: allComposedFromUris } }];
        }
    });
}); };
//# sourceMappingURL=index.js.map